import React, { Dispatch, SetStateAction, useState } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Error } from '../../models/error.model';
import { Company } from '../../models/company.model';
import { StorageCenterDA } from '../../services/admin/storage.center.service';
import { StorageCenter } from '../../models/storage.center.model';
import { GlobalSwal } from '../../styles/swal.style';
import { legendInvalid, legendIconInvalid, legendValidInvalidRestart, legendIconValidInvalidRestart } from '../../utils/legend.data.util';
import { modalHide } from '../../utils/modal.util';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

import AppLoading from '../Loading';
import AppStorageCenterForm from '../../interfaces/main/inventory/storage/component/StorageCenterForm';

export interface AppModalStorageCenterCreateProps {
  companyForUser: Company | null,
  storageCentersForCompany: StorageCenter[] | null,
  storageCenters: StorageCenter[] | null,
  setStorageCenters: Dispatch<SetStateAction<StorageCenter[] | null>>
  loadStorageCentersForCompany: Function
};

let errorResponse: Error, storageCenterResponse: StorageCenter;

const AppModalStorageCenterCreate: React.FunctionComponent<AppModalStorageCenterCreateProps> = ({companyForUser, storageCentersForCompany, storageCenters, setStorageCenters, loadStorageCentersForCompany}) => {
  const {lang} = StateLanguage()

  const [loadIndicator, setLoadIndicator] = useState('off')
  const [name, setName] = useState({value: '', valid: false})
  const [street, setStreet] = useState({value: '',  valid: false})
  const [streetNumber, setStreetNumber] = useState({value: '', valid: true})
  const [additional, setAdditional] = useState({value: '', valid: true})
  const [administrativeArea, setAdministrativeArea] = useState({value: '', valid: false})
  const [city, setCity] = useState({value: '', valid: false})
  const [zipCode, setZipCode] = useState({value: '', valid: true})
  const [country, setCountry] = useState({value: '', valid: false})
  const [isSav, setIsSav] = useState({value: false, valid: true})

  const submitStorageCenterCreate = async () => {
    setLoadIndicator('on')

    if (companyForUser && storageCentersForCompany && name.valid && street.valid && streetNumber.valid && additional.valid && administrativeArea.valid && city.valid && zipCode.valid && country.valid) {
      await StorageCenterDA.postStorageCenter(companyForUser.id, name.value, street.value, streetNumber.value, additional.value, administrativeArea.value, city.value, zipCode.value, country.value, isSav.value).then( (response) => {
        if (response.status === 201) {
          storageCenterResponse = response.data

          if (storageCenters && setStorageCenters) {
            setStorageCenters([storageCenterResponse, ...storageCenters])
          }

          loadStorageCentersForCompany(companyForUser.id)

          GlobalSwal.fire({
            title: lang.labels.successfullyCreatedStorageCenter,
            text: lang.labels.actionCompletedReturningToPage,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            executeHideModalStorageCenterCreate()
          })
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: `${errorResponse.message}!`,
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            confirmButtonText: lang.labels.okGotIt
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      }).finally(() => {
        setLoadIndicator('off')
      })
    } else {
      GlobalSwal.fire({
        text: lang.labels.sorryLooksLikeThereAreSomeErrorsTrySolve,
        icon: 'error',
        showConfirmButton: false,
        timer: 2200
      }).then( () => {
        if (!name.value.length) legendIconInvalid('modal-storage-center-create-input-name', 'modal-storage-center-create-legend-name-required')
        if (!street.value.length) legendIconInvalid('modal-storage-center-create-input-street', 'modal-storage-center-create-legend-street-required')
        if (!administrativeArea.value.length) legendIconInvalid('modal-storage-center-create-input-administrative-area', 'modal-storage-center-create-legend-administrative-area-required')
        if (!city.value.length) legendIconInvalid('modal-storage-center-create-input-city', 'modal-storage-center-create-legend-city-required')
        if (!country.value.length) legendInvalid('modal-storage-center-create-legend-country-required')
        setLoadIndicator('off')
      })
    }
  }

  const executeHideModalStorageCenterCreate = () => {
    modalHide('modal-storage-center-create')

    setTimeout( () => {
      restartModal()
    }, 200 )
  }

  function restartModal() {
    legendIconValidInvalidRestart('modal-storage-center-create-input-name', 'modal-storage-center-create-legend-name-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-name', 'modal-storage-center-create-legend-name-required')
    legendIconValidInvalidRestart('modal-storage-center-create-input-street', 'modal-storage-center-create-legend-street-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-street', 'modal-storage-center-create-legend-street-required')
    legendIconValidInvalidRestart('modal-storage-center-create-input-street-number', 'modal-storage-center-create-legend-street-number-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-additional', 'modal-storage-center-create-legend-additional-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-administrative-area', 'modal-storage-center-create-legend-administrative-area-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-administrative-area', 'modal-storage-center-create-legend-administrative-area-required')
    legendIconValidInvalidRestart('modal-storage-center-create-input-city', 'modal-storage-center-create-legend-city-valid')
    legendIconValidInvalidRestart('modal-storage-center-create-input-city', 'modal-storage-center-create-legend-city-required')
    legendIconValidInvalidRestart('modal-storage-center-create-input-zip-code', 'modal-storage-center-create-legend-zip-code-valid')
    legendValidInvalidRestart('modal-storage-center-create-legend-country-required')

    setName({value: '', valid: false})
    setStreet({value: '', valid: false})
    setStreetNumber({value: '', valid: true})
    setAdditional({value: '', valid: true})
    setAdministrativeArea({value: '', valid: false})
    setCity({value: '', valid: false})
    setZipCode({value: '', valid: true})
    setIsSav({value: false, valid: true})

    setCountry({value: 'CH', valid: true})
  }

  return (
    <div id="modal-storage-center-create" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-capitalize">{lang.labels.createStorageCenter}</h2>
          </div>
          <div className="modal-body">
            { companyForUser
              ?
              <AppStorageCenterForm component={"modal-storage-center-create"} name={name} street={street} streetNumber={streetNumber} additional={additional} administrativeArea={administrativeArea} city={city} zipCode={zipCode} country={country} isSav={isSav} setName={setName} setStreet={setStreet} setStreetNumber={setStreetNumber} setAdditional={setAdditional} setAdministrativeArea={setAdministrativeArea} setCity={setCity} setZipCode={setZipCode} setCountry={setCountry} setIsSav={setIsSav}></AppStorageCenterForm>
              :
              <AppLoading></AppLoading>
            }
          </div>
          <div className="modal-footer flex-center">
            <button className="btn btn-secondary mx-2" type="reset" onClick={executeHideModalStorageCenterCreate}>{lang.labels.cancel}</button>
            <button className="btn btn-primary mx-2" type="button" data-kt-indicator={loadIndicator} onClick={submitStorageCenterCreate}>
              <span className="indicator-label">{lang.labels.create}</span>
              <span className="indicator-progress">
                {lang.labels.pleaseWait}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppModalStorageCenterCreate;
